var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('div',{staticClass:"pp-post-layer-body"},[_c('p',[_vm._v("Hello "+_vm._s(_vm.userName || "")+" 😀 ,")]),_c('p',[_vm._v("We’re so glad you’re here, let us know if you have any questions.")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pp-post-layer-title"},[_vm._v(" Welcome to "),_c('br'),_vm._v(" Upsell & Cross Sell 🎉 ")])
}]

export { render, staticRenderFns }